import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnHuishouden = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#0061CD"
      d="M26.85 20a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#0061CD"
      fillRule="evenodd"
      d="M26.85 20c3.31 0 6 2.69 6 6v8h-12v-8c0-3.31 2.69-6 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#85BDED"
      d="M13.15 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#85BDED"
      fillRule="evenodd"
      d="M13.15 18c3.31 0 6 2.69 6 6v10h-12V24c0-3.31 2.69-6 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M24.63 19.02A4.02 4.02 0 0 1 20.61 15h1c0 1.67 1.35 3.02 3.02 3.02s3.02-1.35 3.02-3.02h1c0 2.22-1.8 4.02-4.02 4.02M13.15 17.02A4.02 4.02 0 0 1 9.13 13h1c0 1.67 1.35 3.02 3.02 3.02s3.02-1.35 3.02-3.02h1c0 2.22-1.8 4.02-4.02 4.02"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnHuishouden);

export default ForwardRef;
